import { VerifyFrom } from "./VerifyFrom";
import { TOP_CNT } from "./constants";
import "./styles/VerifyPage.scss";
import React, { Fragment } from "react";
import { FooterAds } from "../../components/ads/FooterAds";

export const VerifyPage = () => {
  const { title, text } = TOP_CNT;

  return (
    <Fragment>
      <div className="VerifyPage">
        <div className="VerifyPage-TopCnt">
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <VerifyFrom />
      </div>

      <FooterAds/>
    </Fragment>
  );
};
